<template>
  <div class="card kpi-card">
    <div class="kpi-title">{{ title }}</div>
    <div class="kpi-value">
      {{ value !== null && value !== undefined ? value.toFixed(1) : '-' }}<span class="kpi-unit">{{ unit }}</span>
    </div>
    <div v-if="trendDirection && trendDirection !== 'na'" class="kpi-trend" :class="trendDirection">
      <i :class="trendIcon"></i>
      {{ trend !== null && trend !== undefined ? trend.toFixed(1) : '0.0' }}%
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { colors } from '../../../../consts/colors';

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  value: {
    type: Number,
    default: null
  },
  unit: {
    type: String,
    default: '%'
  },
  trend: {
    type: Number,
    default: null
  },
  trendDirection: {
    type: String,
    default: null,
    validator: (value) => value === null || ['up', 'down', 'same', 'na'].includes(value)
  }
});

const trendIcon = computed(() => {
  switch (props.trendDirection) {
    case 'up':
      return 'bi bi-arrow-up';
    case 'down':
      return 'bi bi-arrow-down';
    default:
      return 'bi bi-arrow-right';
  }
});
</script>

<style lang="scss" scoped>
.kpi-card {
  background: v-bind('colors.white');
  border: none;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 3px v-bind('colors.shadowColor');
  height: 100%;

  .kpi-title {
    font-size: 14px;
    font-weight: 600;
    color: v-bind('colors.textPrimary');
    margin-bottom: 8px;
  }

  .kpi-value {
    font-size: 32px;
    font-weight: 700;
    color: v-bind('colors.textPrimary');
    line-height: 1.2;

    .kpi-unit {
      font-size: 14px;
      font-weight: 500;
      margin-left: 2px;
      color: v-bind('colors.gray[500]');
    }
  }

  .kpi-trend {
    display: inline-block;
    width: fit-content;
    margin-top: 8px;
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;

    // The design uses a green badge for up and a muted gray badge for down
    &.up {
      background-color: #d9f2e3;
      color: v-bind('colors.trendUp');
    }

    &.down,
    &.same {
      background-color: v-bind('colors.gray[200]');
      color: v-bind('colors.gray[500]');
    }
  }
}
</style>
